import DOMPurify from 'dompurify';

if (window.trustedTypes?.createPolicy) {
  window.trustedTypes.createPolicy('default', {
    // @ts-expect-error https://github.com/microsoft/TypeScript/issues/30024
    createHTML: (source) => DOMPurify.sanitize(source, { RETURN_TRUSTED_TYPE: true }),
    // Just let scripts and URLs through (Pass-through)
    createScript: (s) => s,
    createScriptURL: (url) => url,
  });
}
